import styled from 'styled-components';

export const BalanceOnHandViewInfoContainerStyle = styled.div`
`;
